class PageLoading {
    constructor() {
    }

}

module.exports = { PageLoading };
